import React from 'react';
import Button from 'react-bootstrap/Button';
import Card from 'react-bootstrap/Card';
import {
  GradesScoreIcon,
  IterationsScoreIcon,
  PerformanceScoreIcon,
} from '../Common/Icons';

const Intro = ({ getStarted, compName }) => (
  <div className="px-3">
    <p>
      <strong>Welcome!</strong> In {compName}, you will progress through
      different and increasingly challenging design scenarios. There are five
      levels to work through, each with its own{' '}
      <strong>Design Challenge</strong>.
    </p>
    <p>
      {' '}
      To move from one level to the next, you'll need to meet a minimum{' '}
      <strong>overall score</strong> by earning points in the three categories
      below:
    </p>

    <Card className="mb-3">
      <Card.Body className="d-flex">
        <GradesScoreIcon className="fs-3 me-3" />
        <div>
          <Card.Title className="d-flex align-items-center">
            <span className="fw-light">Grades</span>
          </Card.Title>
          <Card.Text>
            Earn up to <b>100 points</b> in <strong>Grades</strong> by
            completing quizzes, exercises, and worksheets in the Research
            section. You <b>keep these points</b> when you level up. Remember, a
            clear understanding of Research material will also help you make a
            better design!
          </Card.Text>
        </div>
      </Card.Body>
    </Card>

    <Card className="mb-3">
      <Card.Body className="d-flex">
        <IterationsScoreIcon className="fs-3 me-3" />

        <div>
          <Card.Title className="d-flex align-items-center">
            <span className="fw-light">Iterations</span>
          </Card.Title>
          <Card.Text>
            Earn up to <strong> 50 points</strong> in{' '}
            <strong>Iterations</strong> by testing <strong>in-spec</strong>{' '}
            designs in the Competition. An important part of the engineering
            design process is analysing your design performance and making
            adjustments to improve the next iteration or revision. Hint: Use the
            OUTPUTS tab to check if your design is in-spec.
          </Card.Text>
        </div>
      </Card.Body>
    </Card>

    <Card className="mb-3">
      <Card.Body className="d-flex">
        <PerformanceScoreIcon className="fs-3 me-3" />

        <div>
          <Card.Title className="d-flex align-items-center">
            <span className="fw-light">Performance</span>
          </Card.Title>
          <Card.Text>
            Earn up to <strong>100 points</strong> in{' '}
            <strong>Performance</strong> based on how well your designs perform.
            Each level has its own performance benchmarks according to its
            specification. Designs that meet the best performance target will
            receive the full 100 points, and partial points are awarded as your
            design approaches this target.
          </Card.Text>
        </div>
      </Card.Body>
    </Card>

    <p>
      When you level up, your <strong>Iterations</strong> and{' '}
      <strong>Performance</strong> scores reset so that you can earn them again
      for the next level's challenge. Your <strong>Grades</strong> score carries
      over from level to level. Finally, some levels will also require a minimum
      score in one or more categories to progress.
    </p>
    <p>
      You can see your progress (and these requirements) at any time by clicking
      the progress bar in the top-left menu.
    </p>

    <div className="text-center pt-2">
      <Button onClick={getStarted} variant="wb" className="fw-bold">
        Get Started Now!
      </Button>
    </div>
  </div>
);

export default Intro;
